var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { staticClass: "modal" }, [
        _c("i", {
          staticClass: "close-icon el-icon-close",
          on: { click: _vm.dialogClose }
        }),
        _c("table", { staticClass: "table" }, [
          _c("tr", { staticClass: "gray-row" }, [
            _c("td", { staticClass: "centered-cell" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.ChargeSource")))
            ]),
            _c("td", { staticClass: "centered-cell" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))
            ]),
            _c("td", { staticClass: "centered-cell" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.Weight")))
            ])
          ]),
          _c("tr", [
            _c("td", { staticClass: "centered-cell" }, [
              _vm._v(_vm._s(_vm.$t("CargoMsg.Local")))
            ]),
            _c("td", { staticClass: "centered-cell" }, [
              _vm._v(_vm._s(_vm.data.localQuantity))
            ]),
            _c("td", { staticClass: "centered-cell" }, [
              _vm._v(_vm._s(_vm.data.localWeight))
            ])
          ]),
          _c("tr", [
            _c("td", { staticClass: "centered-cell" }, [
              _vm._v(_vm._s(_vm.$t("CargoMsg.CustomsDocumentPreparation")))
            ]),
            _c(
              "td",
              {
                class: _vm.qualityDiff
                  ? "centered-cell red-text"
                  : "centered-cell"
              },
              [_vm._v(_vm._s(_vm.data.customsQuantity))]
            ),
            _c(
              "td",
              {
                class: _vm.weightDiff
                  ? "centered-cell red-text"
                  : "centered-cell"
              },
              [_vm._v(_vm._s(_vm.data.customsWeight))]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }